import React, { useState, useRef, useEffect, useMemo } from "react";
import cv, { log } from "@techstark/opencv-js";
import { Tensor, InferenceSession } from "onnxruntime-web";
import { detectImage } from "./utils/detect";
import { download } from "./utils/download";

import {
  Flex,
  Text,
  Button,
} from "@chakra-ui/react";
import { OptionDraw, StyleDraw } from "./components/draw";

import Cavans from "./components/cavans";
import VConsole from "vconsole";
// import img1 from "./assert/1.jpg"

if (window.location.href.indexOf("vconsole=1") > -1) {
  const vConsole = new VConsole();
}

// import boxess from "./assert/boxes";
 
const App = () => {
  // Configs
  // const modelName = "yolov8n.onnx";
  // const modelName = "pipe.onnx";
  const modelName = "pipes-5fhtm-2.onnx";
  const modelInputShape = [1, 3, 640, 640];
  const topk = 10000;
  const iouThreshold = 0.15;
  const scoreThreshold = 0.05;
  const [loading, setLoading] = useState({
    text: "加载 OpenCV.js",
    progress: null,
  });

  const [session, setSession] = useState(null);
  const [boxes, setBoxes] = useState([]);
  const [boxes_length, setBoxes_length] = useState(boxes.length);
  const [probability, setProbability] = useState(50);
  const [radius, setRadius] = useState(10);
  const inputImage = useRef(null);
  const [imgUrl, setImageUrl] = useState(null);
  // wait until opencv.js initialized

  cv["onRuntimeInitialized"] = async () => {
    const baseModelURL = `${process.env.PUBLIC_URL}/model`;
    // console.log(baseModelURL);
    try {
      // create session
      const arrBufNet = await download(
        `${baseModelURL}/${modelName}`, // url
        ["加载检测模型", setLoading] // logger
      );
      // console.log("arrBufNet");

      const yolov8 = await InferenceSession.create(arrBufNet);
      // console.log("yolov8");

      const arrBufNMS = await download(
        `${baseModelURL}/nms-yolov8.onnx`, // url
        ["加载筛选模型", setLoading] // logger
      );
      // console.log("arrBufNMS");

      const nms = await InferenceSession.create(arrBufNMS);

      // warmup main model
      setLoading({ text: "预启动...", progress: null });
      const tensor = new Tensor(
        "float32",
        new Float32Array(modelInputShape.reduce((a, b) => a * b)),
        modelInputShape
      );
      await yolov8.run({ images: tensor });

      setSession({ net: yolov8, nms: nms });
      setLoading(null);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    // console.log(imgUrl);
    if (imgUrl) {
      let image = new Image();
      image.src = imgUrl;
      image.onload = async () => {
        let boxes = await detectImage(
          image,
          session,
          topk,
          iouThreshold,
          scoreThreshold,
          modelInputShape
        );
        image = null;
        // console.log(boxes)
        setBoxes(boxes);
      };
    }
  }, [imgUrl]);

  const onInputChage = (e) => {
    // handle next image to detect
    if (imgUrl) {
      URL.revokeObjectURL(imgUrl);
      setImageUrl(null);
    }
    const url = URL.createObjectURL(e.target.files[0]); // create image url
    setBoxes([]);
    setImageUrl(url);
  };

  const boxes_ = useMemo(() => {
    return boxes.filter((box) => box.probability * 100 >= probability);
  }, [probability, boxes]);

  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [isStyleOpen, setIsStyleOpen] = useState(false);

  return (
    <div style={{ touchAction: "none" }}>
      <Flex direction={"column"} width={"100vw"} backgroundColor={"#303030"}>
        <Flex
          height={"50px"}
          alignItems={"center"}
          justifyContent={"center"}
          backgroundColor={"black"}
          color={"white"}
          padding={"7px"}
        >
          <Text fontWeight={700} fontSize={24}>
            {boxes_length}
          </Text>
          <Text>根</Text>
        </Flex>
        <input
          type="file"
          ref={inputImage}
          accept="image/*"
          style={{ display: "none" }}
          onChange={onInputChage}
        />
        <Cavans
          width={window.innerWidth}
          height={window.innerHeight - 50 - 80}
          url={imgUrl}
          boxes={boxes_}
          onBoxesLengthChange={setBoxes_length}
          onRadiusChange={setRadius}
          optionRadius={radius}
        ></Cavans>

        <OptionDraw
          setIsOptionsOpen={setIsOptionsOpen}
          isOptionsOpen={isOptionsOpen}
          probability={probability}
          setProbability={setProbability}
        ></OptionDraw>
        <StyleDraw
          setIsStyleOpen={setIsStyleOpen}
          isStyleOpen={isStyleOpen}
          radius={radius}
          setRadius={setRadius}
        ></StyleDraw>

        <Flex
          height={"80px"}
          alignItems={"center"}
          justifyContent={"space-around"}
          backgroundColor={"black"}
          color={"white"}
          padding={"7px"}
        >
          <Button
            height={"50px"}
            onClick={() => {
              setIsOptionsOpen(true);
            }}
          >
            参数
          </Button>
          <Button
            height={"50px"}
            width={"50%"}
            loadingText={loading?loading.text:""}
            isLoading={loading}
            onClick={() => {
              inputImage.current.click();
            }}
          >
            打开
          </Button>
          <Button
            height={"50px"}
            onClick={() => {
              setIsStyleOpen(true);
            }}
          >
            样式
          </Button>
        </Flex>
      </Flex>
    </div>
  );
};

export default App;
